import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  padding: 0;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;

  .ant-alert-info {
    border: 1px solid ${({ theme }) => theme.colors.black4} !important;
    font-size: 12px !important;
    font-weight: 400 !important;
    line-height: 16px !important;
    color: ${({ theme }) => theme.colors.black9} !important;
  }
`;

export const Title = styled.div`
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.2px;
  color: ${({ theme }) => theme.colors.black9};
`;

export const ObservationCard = styled.div`
  display: flex;
  gap: 8px;
  padding: 12px;
  width: 100%;
  border-radius: 4px;
  border: ${({ theme }) => `1px solid ${theme.colors.black4}`};
  background: ${({ theme }) => theme.colors.blue1};
  color: ${({ theme }) => theme.colors.black9};

  i {
    font-size: 16px;
  }
`;

export const SectionCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  padding: 16px;
  border-radius: 4px;
  border: ${({ theme }) => `1px solid ${theme.colors.black4}`};
  background: ${({ theme }) => theme.colors.white};
`;

export const SectionHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
`;

export const SectionTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
`;

export const HistoryLink = styled.span`
  cursor: pointer;
  color: ${({ theme }) => theme.colors.black9};
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  &:hover {
    background-color: ${({ theme }) => theme.colors.black3};
  }
`;

export const ItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

export const TwoColumns = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px 16px;
  width: 100%;

  @media (min-width: ${({ theme }) => theme.mediaQueries.sm}) {
    grid-template-columns: 1fr 1fr;
  }
`;

export const ExamList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ExamItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ExamHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

export const ExamName = styled.span`
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.black8};
`;

export const ExamProvince = styled.span`
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: ${({ theme }) => theme.colors.black7};
`;

export const ExamDateRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

export const ExamDateText = styled.span`
  white-space: nowrap;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.black7};
`;

export const ExamLink = styled.a`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${({ theme }) => theme.colors.link};
  text-decoration: none;
`;
